import Vue from 'vue'
import VueRouter from 'vue-router'

// Main pages
import Start from './pages/Start'
import Game from './pages/Game'

import Preload from './pages/Preload'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:
  //   {
  //     name: 'Home'
  //   }
  // },
  {
    path: '/start',
    name: 'Start',
    component: Start
  },
  {
    path: '/game',
    name: 'Game',
    component: Game
  },
  {
    path: '/preload',
    name: 'Preload',
    component: Preload
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
